import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css.global`
  .fee-item-contents {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .fee-item-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .fee-item-subtitle {
    font-size: 14px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .fee-item-input-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 8px;
  }
  .fee-item-input-row-container {
    display: flex;
    justify-content: space-between;
  }
  .user-switch-wrapper {
    margin-bottom: 3px;
  }
  .fee-item-date {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .button-container {
    padding: 8px 0;
  }
  .fee-item-contents :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .fee-item-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
  :global(textarea.text-area) {
    resize: none;
    border: solid 1px #676767;
    border-radius: 4px;
    font-size: 16px;
  }
`;

export default style;
